// src/components/HomeHero/HomeHero.jsx
import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import { motion, AnimatePresence } from 'framer-motion';
import styles from './HomeHero.module.scss';

import banner1 from '../../assets/images/HomeHero/home-hero-1.webp';
import banner2 from '../../assets/images/HomeHero/home-hero-2.webp';
import banner3 from '../../assets/images/HomeHero/home-hero-3.webp';

import HomeActionButton from '../HomeActionButton/HomeActionButton';
import HomeQuotaButton from '../HomeQuotaButton/HomeQuotaButton';

const HomeHero = ({ scrollToContact, onOpenCotizador }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [displayedSublabel, setDisplayedSublabel] = useState('');
  const slides = [banner1, banner2, banner3];

  const fullSublabel =
    'Maquinaria de alta calidad que integra tecnología, experiencia y sustentabilidad.';

  // Preload primera imagen
  useEffect(() => {
    const img = new Image();
    img.src = slides[0];
    img.onload = () => setIsLoaded(true);
  }, [slides]);

  // Máquina de escribir para el sublabel (velocidad doblada: 25ms)
  useEffect(() => {
    if (!isLoaded) return;
    let idx = 0;
    const interval = setInterval(() => {
      setDisplayedSublabel(fullSublabel.slice(0, idx + 1));
      idx += 1;
      if (idx >= fullSublabel.length) {
        clearInterval(interval);
      }
    }, 25); // <-- aquí ajustamos de 50 ms a 25 ms
    return () => clearInterval(interval);
  }, [isLoaded, fullSublabel]);

  const settings = {
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: false,
    cssEase: 'ease-in-out',
  };

  // Variants Framer Motion
  const flashVariant = {
    initial: { opacity: 1 },
    animate: { opacity: 1 },
    exit: { opacity: 0, transition: { duration: 0.5 } },
  };
  const imageVariant = {
    initial: { x: 200, opacity: 0 },
    animate: {
      x: 0,
      opacity: 1,
      transition: { type: 'spring', stiffness: 60, damping: 12 },
    },
  };
  const textVariant = {
    initial: { y: 50, opacity: 0 },
    animate: {
      y: 0,
      opacity: 1,
      transition: { type: 'spring', stiffness: 50, damping: 10 },
    },
  };
  const buttonVariant = {
    initial: { scale: 0.8, opacity: 0 },
    animate: {
      scale: 1,
      opacity: 1,
      transition: { type: 'spring', stiffness: 300, damping: 20 },
    },
    whileHover: { scale: 1.1 },
  };

  return (
    <div className={styles.heroContainer}>
      <AnimatePresence>
        {!isLoaded && (
          <motion.div
            className={styles.flashOverlay}
            variants={flashVariant}
            initial="initial"
            animate="animate"
            exit="exit"
          />
        )}
      </AnimatePresence>

      {isLoaded && (
        <>
          <Slider {...settings} className={styles.slider}>
            {slides.map((src, idx) => (
              <div key={idx} className={styles.slide}>
                <motion.img
                  src={src}
                  alt={`Banner ${idx + 1}`}
                  className={styles.image}
                  variants={imageVariant}
                  initial="initial"
                  animate="animate"
                />
              </div>
            ))}
          </Slider>

          <div className={styles.content}>
            <motion.h2
              className={styles.visionLabel}
              variants={textVariant}
              initial="initial"
              animate="animate"
            >
              VISIÓN QUE CREA FUTURO
            </motion.h2>

            {/* Subtítulo con efecto máquina de escribir */}
            <p
              className={`${styles.visionSublabel} ${
                displayedSublabel.length < fullSublabel.length
                  ? styles.typing
                  : ''
              }`}
            >
              {displayedSublabel}
            </p>

            <div className={styles.actionContainer}>
              <motion.div
                variants={buttonVariant}
                initial="initial"
                animate="animate"
                whileHover="whileHover"
              >
                <HomeQuotaButton onOpenCotizador={onOpenCotizador} />
              </motion.div>
              <motion.div
                variants={buttonVariant}
                initial="initial"
                animate="animate"
                whileHover="whileHover"
              >
                <HomeActionButton onClick={scrollToContact} />
              </motion.div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default HomeHero;
